export default "__VITE_ASSET__BKuPDoP2__"